/**
 * External dependencies.
 */
 import defaultsDeep from 'lodash/defaultsDeep';

/**
 * Internal dependencies.
 */
import { ref, computed } from 'vue';

const defaultOptions = {
    resetBeforeEnter: false,
    initialTab: null,
};

export default function useTabs(options) {
    const currentTab = ref(null);
    
    const {
        resetBeforeEnter,
        initialTab,
    } = defaultsDeep(options, defaultOptions);

    if (resetBeforeEnter) {
        currentTab.value = null;
    }

    if (initialTab) {
        currentTab.value = initialTab;
    }

    const goToTab = (tab) => {
        currentTab.value = tab;
    };

    return {
        goToTab,
        currentTab: computed(() => currentTab.value),
    };
}
 